import React, {useEffect, useState} from "react";
import API from "../../../apiService";
import ALERT from "../../component/Alert";

const Rekonsiliasi = ({anamnese, setAnamnese, rekonsiliasi_obat, add, cancelNew}) => {
  return (
    <div className="card">
      <div className="card-header">
        <div className="row align-items-center">
          <div className="col-12">
            <div className={'d-flex'}>
              <h4 className="h3 mb-0">Rekonsiliasi Obat</h4>
              <div style={{flex: 1}}></div>
              <button className={'btn btn-sm btn-success'} onClick={add}>
                <i className={'fa fa-plus'}></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body" style={{background: '#ffd6d6'}}>
        <table className={'table table-bordered'}>
          <thead>
          <tr>
            <th>No</th>
            <th>Nama Obat</th>
            <th>Signa</th>
            <th>Lanjut</th>
            <th>Aksi</th>
          </tr>
          </thead>
          <tbody>
          {rekonsiliasi_obat?.filter(v => v.name || v.new).map((v, k) => (
            <RekonsiliasiRow
              key={`rekon-${k}`}
              row={v}
              index={k}
              anamnese={anamnese}
              setAnamnese={setAnamnese}
              all={rekonsiliasi_obat}
              cancelNew={cancelNew}
            />
          ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const RekonsiliasiRow = ({row, index, anamnese, setAnamnese, all, cancelNew}) => {

  const [editing, setEditing] = useState(!!row.new)
  const [saving, setSaving] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const [name, setName] = useState(row.name)
  const [signa1, setSigna1] = useState(row.signa1)
  const [signa2, setSigna2] = useState(row.signa2)
  const [status, setStatus] = useState(row.status)

  useEffect(() => {
    if (editing) {
      setName(row.name)
      setSigna1(row.signa1)
      setSigna2(row.signa2)
      setStatus(row.status)
    }
  }, [editing])

  const batal = () => {
    setEditing(false)
    cancelNew()
  }

  const save = async () => {
    if (!name) {
      alert('Masukkan nama obat')
      return
    }

    setEditing(false)
    setSaving(true)

    const new_rekon = {
      ...row,
      name,
      signa1,
      signa2,
      status,
    }
    const rekons = all
      .map((v, k) => k === index ? new_rekon : v)
      .map(v => {
        delete v.new
        return v
      })
    const param = {...anamnese, rekonsiliasi_obat: JSON.stringify(rekons)};
    const res = await API.put("management/anamneses/update", param);
    if (res.code === 200) {
      ALERT("success", "Berhasil Menyimpan Data ");
      setAnamnese(res.data)
    }
    else {
      ALERT("error", "gagal menyimpan data");
    }
    setSaving(false)
  }

  const hapus = async () => {
    if (!confirm('Yakin hapus rekonsiliasi obat ini?')) {
      return
    }

    setDeleting(true)
    const rekons = all.filter((v, k) => k !== index)
    const param = {...anamnese, rekonsiliasi_obat: JSON.stringify(rekons)};
    const res = await API.put("management/anamneses/update", param);
    if (res.code === 200) {
      ALERT("success", "Berhasil Menyimpan Data ");
      setAnamnese(res.data)
    }
    else {
      ALERT("error", "gagal menyimpan data");
    }
    setDeleting(false)
  }

  return editing || saving ? (
    <tr>
      <td>{index + 1}</td>
      <td>
        <input type={'text'} className={'form-control form-control-sm'} value={name} onChange={e => setName(e.target.value)}/>
      </td>
      <td>
        <div className={'d-flex align-items-center'}>
          <input type={'number'} className={'form-control form-control-sm'} value={signa1} onChange={e => setSigna1(e.target.value)} style={{maxWidth: 70}}/>
          x
          <input type={'number'} className={'form-control form-control-sm'} value={signa2} onChange={e => setSigna2(e.target.value)} style={{maxWidth: 70}}/>
        </div>
      </td>
      <td>
        <label className="custom-toggle custom-toggle-success">
          <input
            type="checkbox"
            name="status"
            checked={!!status}
            onChange={(e) => setStatus(e.target.checked)}
          />
          <span
            className="custom-toggle-slider rounded-circle"
            data-label-off="tidak"
            data-label-on="lanjut"
          />
        </label>
      </td>
      <td>
        <button className={'btn btn-success btn-sm'} disabled={saving} onClick={save}>{saving ? 'Menyimpan...' : 'Simpan'}</button>
        {!saving && <button className={'btn btn-danger btn-sm'} onClick={batal}>Batal</button>}
      </td>
    </tr>
  ) : (
    <tr>
      <td>{index + 1}</td>
      <td>{row.name}</td>
      <td>{row.signa1} x {row.signa2}</td>
      <td>{row.status ? 'Ya' : 'Tidak'}</td>
      <td>
        {!deleting && <>
          <button className={'btn btn-warning btn-sm'} onClick={() => setEditing(true)}>Edit</button>
          <button className={'btn btn-danger btn-sm'} onClick={hapus}>Hapus</button>
        </>}
        {deleting && <button className={'btn btn-danger btn-sm'} disabled={true}>Menghapus...</button>}
      </td>
    </tr>
  )
}

export default Rekonsiliasi